<ng-content></ng-content>

<div class="menu-container">
  <dx-tree-view
    [items]="items"
    keyExpr="key"
    selectionMode="single"
    [searchEnabled]="!compactMode"
    searchExpr="searchText"
    searchMode="contains"
    [searchEditorOptions]="searchEditorOptions"
    [expandNodesRecursive]="false"
    [focusStateEnabled]="false"
    expandEvent="click"
    (onItemExpanded)="onItemExpanded($event)"
    (onItemClick)="onItemClick($event)"
    width="100%"
  />
</div>
<ng-content select="app-footer"></ng-content>
